import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { Icon } from "@iconify/react";
import { usePromiseTracker } from "react-promise-tracker";

const FormContainer = ({ children, className }) => {
  const formContainerRef = useRef(null);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  // Track scroll position to show or hide the scroll-to-top button
  const handleScroll = () => {
    if (formContainerRef.current) {
      const scrollTop = formContainerRef.current.scrollTop;
      setShowScrollToTop(scrollTop > 100); // Show button if scrolled down more than 100px
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    if (formContainerRef.current) {
      formContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Attach scroll event listener
  useEffect(() => {
    const formContainer = formContainerRef.current;
    if (formContainer) {
      formContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (formContainer) {
        formContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div
      className={`${className} form-container form-con`}
      ref={formContainerRef}
    >
      {children}

      {showScrollToTop && !promiseInProgress && (
        <div
          className={`scroll-to-top-btn ${
            showScrollToTop ? "visible scroll-up-animation" : ""
          }`}
          onClick={scrollToTop}
        >
          <Icon icon="fluent-emoji:up-arrow" width="2rem" height="2rem" />
        </div>
      )}
    </div>
  );
};

export default FormContainer;
